import { render, staticRenderFns } from "./dates-prices-filter-ships.vue?vue&type=template&id=cf725c98"
import script from "./dates-prices-filter-ships.vue?vue&type=script&lang=js"
export * from "./dates-prices-filter-ships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports